var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 169,
    viewBox: "0 0 290 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_15)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 242,
    height: 121,
    rx: 6,
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_15",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 242,
    height: 121
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C24 26.6863 26.6863 24 30 24H260C263.314 24 266 26.6863 266 30V145H24V30Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 67.8281,
    cy: 167.92,
    rx: 109.828,
    ry: 76.8489,
    fill: "#4C862E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 193,
    cy: 192.072,
    rx: 116,
    ry: 77,
    fill: "#4C862E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 88.0855L119.563 76.523L144.229 88.0855L171.209 76.523L182 85.0022L172.75 89.1133V111.211L144.229 122.002L115.708 111.211V91.2596L108 88.0855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.813 73.4397L119.563 76.523M119.563 76.523L108 88.0855L115.708 91.2596M119.563 76.523L144.229 88.0855M144.229 88.0855L134.208 98.8773L115.708 91.2596M144.229 88.0855L154.25 97.3356L172.75 89.1133M144.229 88.0855L171.209 76.523M144.229 88.0855V122.002M171.209 76.523L182 85.0022L172.75 89.1133M171.209 76.523L159.646 73.4397M144.229 122.002L172.75 111.211V89.1133M144.229 122.002L115.708 111.211V91.2596",
    stroke: "#B9B9B9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5 53.0002L150.007 62.3389L161 64.4592L153.41 72.3511L154.698 83.0002L144.5 78.5389L134.302 83.0002L135.409 73.8452L135.59 72.3511L128 64.4592L138.993 62.3389L144.5 53.0002Z",
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 47.0002V50.0002",
    stroke: "#B9B9B9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.618 53.7258L154.222 55.5312",
    stroke: "#B9B9B9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.383 53.7248L134.778 55.5303",
    stroke: "#B9B9B9",
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_15",
    x: 0,
    y: 0,
    width: 290,
    height: 169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_15"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_15",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.43dd4bd8565a406fef881fd0f50b5395.svg";
export { ForwardRef as ReactComponent };